const Index = () => import('./Index.vue')
const Organization = () => import('./Organization.vue')
const OrganizationModal = () => import('./OrganizationModal.vue')
const OrganizationBilling = () => import('./OrganizationBilling.vue')

export default [
  {
    name: 'organizations',
    path: 'organizations',
    component: Index,
    meta: {
      superAdminOnly: true
    },
    children: [
      {
        name: 'organization-edit',
        path: 'organization/:organizationId/edit',
        components: {
          modal: OrganizationModal
        },
        meta: {
          showModal: true,
          superAdminOnly: true
        }
      },
      {
        name: 'organization-new',
        path: 'new',
        components: {
          modal: OrganizationModal
        },
        meta: {
          showModal: true,
          superAdminOnly: true
        }
      }
    ]
  },
  {
    name: 'organization',
    path: 'organization/:organizationId/details',
    component: Organization,
    meta: {
      superAdminOnly: true
    },
    children: [
      {
        name: 'selectedOrganization-edit',
        path: 'edit-table',
        components: {
          modal: OrganizationModal
        },
        meta: {
          showModal: true,
          superAdminOnly: true
        }
      }
    ]
  },
  {
    name: 'organization-billing',
    path: 'organization/:organizationId/billing',
    component: OrganizationBilling,
    meta: {
      superAdminOnly: true
    }
  }
]
